import { shouldDisplayFolderInFolderTree } from '../util/folderUtility';
import getFolderTable from './getFolderTable';

export function hasDisplayableChildFolders(folderId: string): boolean {
    const folder = getFolderTable().get(folderId);

    if (!folder.childFolderIds) {
        return false;
    }

    const visibleFolders = folder.childFolderIds.filter((childFolderId: string) => {
        const childFolder = getFolderTable().get(childFolderId);
        return shouldDisplayFolderInFolderTree(childFolder);
    });

    return visibleFolders.length > 0;
}
